import { render, staticRenderFns } from "./ConfigureNewRepeatableDataAdd.vue?vue&type=template&id=0d09b3d3&scoped=true"
import script from "./ConfigureNewRepeatableDataAdd.vue?vue&type=script&lang=js"
export * from "./ConfigureNewRepeatableDataAdd.vue?vue&type=script&lang=js"
import style0 from "./ConfigureNewRepeatableDataAdd.vue?vue&type=style&index=0&id=0d09b3d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d09b3d3",
  null
  
)

export default component.exports